import routes from './routes'

/* @ngInject */
const Routingoutes = (
  $stateProvider,
  $urlRouterProvider,
  $locationProvider
) => {
  $urlRouterProvider.otherwise('/accueil')
  $locationProvider.html5Mode(true).hashPrefix('!')

  $stateProvider
    .state(routes.index.path, {
      url: routes.index.url,
      redirectTo: routes.home.path,
      template: require('./templates/index.html'),
      data: {
        pageTitle: 'Index',
      },
    })
    .state(routes.home.path, {
      url: routes.home.url,
      template: require('./templates/home.html'),
      data: {
        pageTitle: 'Accueil',
      },
    })
}

export default Routingoutes



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/routing.routes.js